import React from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "native-base";

import { FilterKey } from "../../../../../types";
import FilterChip from "./FilterChip";
import { useAppContext } from "../../../../../../Universal/API/Context-API/AppContext";
import { webFont } from "../../../../../../Universal/API/API";

type FilterSectionChipsProps = {
  title: string;
  filterKey: FilterKey;
  options: string[];
  selectedValues: string[];
  unavailableSet: Set<string>;
  onToggle: (key: FilterKey, value: string) => void;
  disabled?: boolean;
  inlineLabel?: boolean;
};

const FilterSectionChips: React.FC<FilterSectionChipsProps> = ({
  title,
  filterKey,
  options,
  selectedValues,
  unavailableSet,
  onToggle,
  disabled = false,
  inlineLabel = false,
}) => {
  const { scaleAll } = useAppContext();
  const styles = React.useMemo(() => createStyles(scaleAll), [scaleAll]);

  return (
    <>
      {!inlineLabel && (
        <Text selectable={false} style={styles.title}>
          {title}
        </Text>
      )}

      <View style={styles.chipsRow}>
        {options.map((opt) => {
          const active = selectedValues.some(
            (value) => value.toLowerCase() === opt.toLowerCase()
          );
          const chipDisabled = disabled || unavailableSet.has(opt.toLowerCase());
          const label = opt.charAt(0).toUpperCase() + opt.slice(1);

          return (
            <FilterChip
              key={`${filterKey}:${opt}`}
              label={label}
              active={active}
              disabled={chipDisabled}
              onPress={() => onToggle(filterKey, opt)}
            />
          );
        })}
      </View>
    </>
  );
};

const createStyles = (scaleAll: number) =>
  StyleSheet.create({
    title: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#6B665F",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: 0.7,
      marginBottom: 10 * scaleAll,
    },
    chipsRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 8 * scaleAll,
      alignItems: "center",
    },
  });

export default React.memo(FilterSectionChips);
